import type { CalloutComponent } from "../../types";
import { RuntimeLink } from "../../runtime/RendererRuntime";
import { resolveLinkHref } from "../../utils/links";

/** Call-to-action callout renderer with title and link. */
export function CalloutRenderer({ component }: { component: CalloutComponent }) {
  const { title, linkHref, linkLabel } = component.content;
  const resolvedHref = resolveLinkHref(linkHref);
  return (
    <section className="rounded-r-xl border-l-4 border-[#00B862] bg-[var(--color-surface-1)] p-4 md:p-5">
      <h2 className="font-semibold text-[#0A0A0A]">{title}</h2>
      {resolvedHref && linkLabel ? (
        <RuntimeLink href={resolvedHref} className="group mt-2 inline-flex items-center gap-2 text-sm font-medium text-[#00935A] hover:underline xl:text-base">
          {linkLabel} <span aria-hidden className="transition-transform group-hover:translate-x-0.5">›</span>
        </RuntimeLink>
      ) : null}
    </section>
  );
}


